import React, { useState } from "react";
import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import currency from "currency.js";
import LineItemDetails from "./LineItemDetails";
import Images from "./image/Images";

export default function LineItemV2(props) {
  const { item } = props;

  const [showMore, setShowMore] = useState(Boolean(props.showMore));

  return (
    <Box sx={{ display: "flex", gap: "10px" }}>
      <Box sx={{ minWidth: "48px", width: "48px" }}>
        <Images pics={item.images} />
      </Box>
      <Box sx={{ flexGrow: "1" }}>
        <Typography variant="body1">{item.title}</Typography>
        {props.view === "min" ? (
          <Box pt={0.25}>
            {showMore && (
              <Box sx={{ borderLeft: "2px solid #ECECEC", paddingLeft: "10px" }}>
                <LineItemDetails item={item} />
              </Box>
            )}
            {item.variant && Object.keys(item.variant).length > 0 && (
              <Button size="small" onClick={() => setShowMore(!showMore)}>
                {showMore ? "LESS" : "MORE"}
              </Button>
            )}
          </Box>
        ) : (
          <LineItemDetails item={item} />
        )}
      </Box>
      <Box sx={{ minWidth: "3rem" }}>
        <Chip size="small" label={item.quantity} />
      </Box>
      <Box sx={{ minWidth: "4rem", textAlign: "right" }}>
        <Typography variant="overline">{currency(item.total || item.price).format()}</Typography>
      </Box>
    </Box>
  );
}
